import * as queryStaff from './reducers/query';
import * as updateStaff from './reducers/update';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    STAFF_QUERY_REQUEST: queryStaff.request,
    STAFF_QUERY_FINISH: queryStaff.finish,
    STAFF_QUERY_ERROR: queryStaff.error,

    STAFF_UPDATE_REQUEST: updateStaff.request,
    STAFF_UPDATE_FINISH: updateStaff.finish,
    STAFF_UPDATE_ERROR: updateStaff.error,
});
